import Pannel from "./pannel.jsx";

export default Pannel;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/pannel/index.js